// src/utils/analytics/AnalyticsTracker.jsx
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initGA, trackPageView } from './GoogleAnalytics';

const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    initGA(); // Initialize only once
  }, []);

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);

  return null;
};

export default AnalyticsTracker;
